function mapClick() {
  const map = document.querySelector('.js-map');
  const btns = document.querySelectorAll('.js-map-btn');
  if (!map || btns.length === 0) return;

  const path = map.querySelectorAll('.-group');

  btns.forEach((btn) => {
    btn.addEventListener(
      'pointerenter',
      () => {
        const area = btn.dataset.area;
        // data-area に対応するエリアがない場合は何もしない
        const target = area ? map.querySelector('.' + CSS.escape(area)) : null;
        if (!target) return;

        path.forEach((group) => group.classList.remove('is-active'));
        btns.forEach((other) => other.classList.remove('is-active'));
        btn.classList.add('is-active');
        target.classList.add('is-active');
      },
      { passive: true }
    );
  });
}

export { mapClick };
